import React from 'react';
import './work.css';
import Works from './Works';

const Work = () => {
  return (
    <section className="work section" id='portfolio'>
        <h2 className="section__title">
            Portfolio
        </h2>
        <span className="work__subtitle">My Projects</span>
        <span className="github__api">All the projects below are fetched live using the 
        <b><a className="gitlink" href="https://docs.github.com/en/rest?apiVersion=2022-11-28"> GitHub API</a></b></span>

        <Works />
    </section>
  )
}

export default Work